/**
 * Determines the visibility status of a doc space.
 * Takes into account wiki groups, access grants, owner, and child directories
 * with overrideAccess to ensure consistent results across all dashboard components.
 *
 * @param {Array} grants - accessGrants array from the space
 * @param {Array} wikiGroupIds - wikiGroupIds array (numbers)
 * @param {number} ownerId - space owner UID
 * @param {Array} childDirectories - sub-directories with { overrideAccess, accessGrants }
 * @returns {'private'|'shared'|'open'}
 */
export function getSpaceVisibility(grants, wikiGroupIds, ownerId, childDirectories = []) {
  if (wikiGroupIds.length > 0) return 'shared';
  if (grants.length === 0) return 'open';

  const onlyOwner = grants.length === 1
    && grants[0].grantType === 'user'
    && String(grants[0].targetId) === String(ownerId);

  if (!onlyOwner) return 'shared';

  const hasSharedChild = childDirectories.some((dir) => {
    if (!dir.overrideAccess) return false;
    const cGrants = dir.accessGrants || [];
    return cGrants.length > 0;
  });

  return hasSharedChild ? 'shared' : 'private';
}
